/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_Revoke_NoteInputs */

const en_us2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawing deletes every photo. The numbers stay, because the numbers are your trend.`)
};

const pt_br2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar apaga todas as fotos. Os números ficam, porque os números são a sua evolução.`)
};

const es_419_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar el permiso borra todas las fotos. Los números se quedan, porque los números son tu evolución.`)
};

const pt_pt2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar apaga todas as fotos. Os números ficam, porque os números são a tua evolução.`)
};

const fr_fr2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'autorisation supprime toutes les photos. Les chiffres restent, car ce sont eux qui montrent ton évolution.`)
};

const de_de2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Widerruf löscht alle Fotos. Die Zahlen bleiben, denn die Zahlen sind dein Verlauf.`)
};

const it_it2_body_assessment_consent_revoke_note = /** @type {(inputs: Body_Assessment_Consent_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revocare elimina tutte le foto. I numeri restano, perché i numeri sono il tuo andamento.`)
};

/**
* | output |
* | --- |
* | "Withdrawing deletes every photo. The numbers stay, because the numbers are your trend." |
*
* @param {Body_Assessment_Consent_Revoke_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoke_note = /** @type {((inputs?: Body_Assessment_Consent_Revoke_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_Revoke_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoke_note(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoke_note(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoke_note(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoke_note(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoke_note(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoke_note(inputs)
	return en_us2_body_assessment_consent_revoke_note(inputs)
});
export { body_assessment_consent_revoke_note as "body-assessment.consent_revoke_note" }